import React from 'react';
import AppDrawer from './AppDrawer';
import SimplePage, { SimplePageProps } from './SimplePage';

export default (props: Omit<SimplePageProps, 'drawerContent'>) => (
  <SimplePage {...props} drawerContent={<AppDrawer />} />
);
